import {
  clearUserSession,
  getUserSessionStorage,
  isSessionExpired
} from '@/composables/useSessions'
import { setSnackbar } from '@/composables/useSnackbar'
import {
  NavigationGuard,
  RouteLocationNormalized,
  NavigationGuardNext
} from 'vue-router'
import { basketState } from '@/composables/useBasket'

export const authenticate: NavigationGuard = (to, _from, next) => {
  const session = getUserSessionStorage()
  if (!session) {
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  }

  // The token is short-lived and the API cannot always be relied on to reject a lapsed one,
  // so drop the session here rather than rendering a page that will silently show no data.
  if (isSessionExpired(session)) {
    clearUserSession()
    setSnackbar('Your session has expired. Please sign in again.')
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  }

  return next()
}

export const redirectIfLoggedIn: NavigationGuard = (to, _from, next) => {
  const session = getUserSessionStorage()
  if (!session) return next()
  // An expired session must not bounce the user away from the page that would renew it.
  if (isSessionExpired(session)) {
    clearUserSession()
    return next()
  }

  const { redirect } = to.query
  if (typeof redirect === 'string' && redirect.startsWith('/')) {
    return next(redirect)
  }
  return next({ name: 'MyAccount' })
}

export const checkBasketPresence: NavigationGuard = (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (!basketState.basketId) {
    next({ name: 'Home' })
  } else next()
}
